export default {
  coupon: {
    MemebrName: 'Memebr Name',
    StoreName: 'Store Name',
    UseDate: 'Use Date',
    Product: 'Product',
    ArriveTime: 'Arrive Time',
    FaceValue: 'Face Value',
    LogisticsCode: 'Logistics Code'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/mmc/eurlate/coupon.js